import { NonIdealState } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import * as React from "react";
import { PageBase } from "../components";
import { useCommonHooks } from "../hooks";
import { ETLCodes } from "../locales";

interface IUnauthorizedPageProps {}

export const UnauthorizedPage: React.FunctionComponent<IUnauthorizedPageProps> =
  () => {
    const { t } = useCommonHooks();

    return (
      <PageBase>
        <NonIdealState
          title={t(ETLCodes.ErrorMessage_Unauthorized_title)}
          icon={IconNames.CROSS}
          description={t(ETLCodes.ErrorMessage_Unauthorized)}
        />
      </PageBase>
    );
  };
